import EntryActionTypes from '../constants/EntryActionTypes';

const updatePointSystemInCurrentBoard = (isEnabled) => ({
  type: EntryActionTypes.POINT_SYSTEM_IN_CURRENT_BOARD_UPDATE,
  payload: {
    isEnabled,
  },
});

const updateBoardPointSystemSettings = (data) => ({
  type: EntryActionTypes.BOARD_POINT_SYSTEM_SETTINGS_UPDATE,
  payload: {
    data,
  },
});

const openPointSystemModalInCurrentBoard = () => ({
  type: EntryActionTypes.POINT_SYSTEM_MODAL_OPEN_IN_CURRENT_BOARD,
  payload: {},
});

const openPointSystemModalInCurrentProject = () => ({
  type: EntryActionTypes.POINT_SYSTEM_MODAL_OPEN_IN_CURRENT_PROJECT,
  payload: {},
});

export default {
  updatePointSystemInCurrentBoard,
  updateBoardPointSystemSettings,
  openPointSystemModalInCurrentBoard,
  openPointSystemModalInCurrentProject,
};
